module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/point-1-dee3bb4de51c39c35a433ca0e30d58ac.jpg";